module.exports = __webpack_public_path__ + "static/udn-img-795fdbdb96c309db8bb8f1526e37df0e.png";